import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { EventMessage, EventType, AuthenticationResult } from '@azure/msal-browser';
import { AnalyticsService } from '@services/analytics.service';
import { ColorService } from '@services/color.service';
import { Logger } from '@services/logging.service';
import { UserService } from '@services/user.service';
import { WebAppService } from '@services/xhr/web-app-svc';
import { Subject, Subscription } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { BreadcrumbService } from './full/header/breadcrumb/breadcrumb.service';
import {GoogleAnalyticsService} from "@services/google-analytics.service";


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  userServiceStatus = 'loading';
  subscription: Subscription;
  theme: string;
  private readonly destroying$ = new Subject<void>();

  constructor(
    private analyticsService: AnalyticsService,
    private breadcrumbService: BreadcrumbService,
    private userService: UserService,
    private colorService: ColorService,
    private webAppService: WebAppService,
    private router: Router,
    private msalService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
  ) {
    this.breadcrumbService.trackRouteChanges();
    this.userService.userServiceStatus$.subscribe(userServiceStatus => {
      this.userServiceStatus = userServiceStatus;
      if (userServiceStatus === 'loaded') {
        this.handlingRouting();
        this.analyticsService.init();
        this.userService.userServiceStatus$.unsubscribe();
      }
    });
  }

  ngOnInit(): void {
    this.subscription = this.colorService.colors$.subscribe();

    // MSAL: handle the redirect callback after Azure login
    this.msalService.handleRedirectObservable().subscribe();

    // MSAL: listen for login success and set the active account
    this.msalBroadcastService.msalSubject$
      .pipe(
        filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        takeUntil(this.destroying$),
      )
      .subscribe((result: EventMessage) => {
        const payload = result.payload as AuthenticationResult;
        this.msalService.instance.setActiveAccount(payload.account);
        Logger.debug('[MSAL] Login success, active account set:', payload.account?.username);
      });

    // MSAL: set active account on page load if already logged in
    const accounts = this.msalService.instance.getAllAccounts();
    if (accounts.length > 0) {
      this.msalService.instance.setActiveAccount(accounts[0]);
    }
  /*    this.router.events
        .pipe(filter((event: any) => event instanceof NavigationEnd))
        .subscribe((event: NavigationEnd) => {
          console.log('NavigationEnd:', event);
          /!*gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects
          });*!/
        });*/

   /* this.router.events
      .pipe(filter(event => event instanceof ActivationEnd))
      .subscribe((event: any) => {
        const component = event.snapshot.component;
        if (component) {
          console.log('Loaded component:', component.name); // <- Component class name
        }
      });*/

  }

  handlingRouting() {
    const DEFAULT_HOMEPAGE: string = 'release-notes';

    let decodedLocallyStoredRoute;
    const LOCALLY_STORED_ROUTE: string | null = localStorage.getItem('appRoute');

    if (LOCALLY_STORED_ROUTE) {
      decodedLocallyStoredRoute = decodeURIComponent(LOCALLY_STORED_ROUTE);
      localStorage.removeItem('appRoute');
      const CURRENT_ROUTE = window.location.pathname;
      const HOME_ROUTES = ['', '/'];
      if (decodedLocallyStoredRoute) {
        const queryParams = this.getParams(decodedLocallyStoredRoute);
        const routeSansQueryParams = decodedLocallyStoredRoute.split('#')[1].split('?')[0];
        if (HOME_ROUTES.includes(decodedLocallyStoredRoute)) {
          this.router.navigate(['/'.concat(DEFAULT_HOMEPAGE)]);
        } else {
          this.router.navigate(['/'.concat(routeSansQueryParams)], { queryParams });
        }
      } else if (!CURRENT_ROUTE || HOME_ROUTES.includes(CURRENT_ROUTE)) {
        this.router.navigate(['/'.concat(DEFAULT_HOMEPAGE)]);
      }
    }

  }

  getParams(url: string) {
    const params: { [key: string]: string; } = {};
    const queryString = url.split('?')[1];
    if (queryString) {
      const vars = queryString.split('&');
      for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=');
        params[pair[0]] = decodeURIComponent(pair[1]);
      }
      return params;
    }
    return {};
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.destroying$.next();
    this.destroying$.complete();
  }

}
